import { useState } from "react";
import "./Tabs.css";
import Tab1Module from "../../icons/для руководства/левый нижний угол/Модули.png"
import Ruler from "../../icons/для руководства/левый нижний угол/Линейка.png"
import NavBarIcon from "../../icons/NavBarIcons/1x/twotone_miscellaneous_services_black_24dp.png"
import TimeLineIcon from "../../icons/timeLineButton/1x/outline_calendar_month_black_24dp.png"
import NavBar from "../../icons/для руководства/NavBar/развернутый NavBar.png"
import NavBarPNG from "../../icons/для руководства/NavBar/иконка.png"
import ModalPNG from "../../icons/для руководства/NavBar/Модальные окна.png"
import ModalListPNG from "../../icons/для руководства/NavBar/Выбор региона.png"
import TBB from "../../icons/для руководства/NavBar/ТВВ + карта.png"
import RegionZone from "../../icons/для руководства/NavBar/Границы регионов.png"
import NatureReservesPNG from "../../icons/для руководства/NavBar/Заповедники.png"
import CityTBB from "../../icons/для руководства/NavBar/пункты + твв.png"
import SuomiNPP from "../../icons/для руководства/NavBar/suomi.png"
import SortNavBar from "../../icons/для руководства/NavBar/сортировка(вся).png"
import Calendar from  "../../icons/для руководства/NavBar/Календарь.png"
import CalendarInfo from "../../icons/для руководства/NavBar/Календарь(выбор промежутка из дат).png"
import TimeLinePNG from "../../icons/для руководства/TimeLine/иконка.png"
import TimeLineFirst from "../../icons/для руководства/TimeLine/первый этап.png"
import TimeLineYear from "../../icons/для руководства/TimeLine/второй этап.png"
import TimeLineMounth from "../../icons/для руководства/TimeLine/третий этап.png"
import TimeLineDays from "../../icons/для руководства/TimeLine/вывод дней.png"
import TimeLineSelectDay from "../../icons/для руководства/TimeLine/день выбран.png"

function Tabs() {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <div className="container">
            <div className="bloc-tabs">
                <button
                    className={toggleState === 1 ? "tabs active-tabs" : "tabs tabsNotActive"}
                    onClick={() => toggleTab(1)}
                >
                    Модули дополнительной информации
                </button>
                <button
                    className={toggleState === 2 ? "tabs active-tabs" : "tabs tabsNotActive"}
                    onClick={() => toggleTab(2)}
                >
                    Дополнительный набор инструментов<br/>(<img src={NavBarIcon}></img>)
                </button>
                <button
                    className={toggleState === 3 ? "tabs active-tabs" : "tabs tabsNotActive"}
                    onClick={() => toggleTab(3)}
                >
                    Модуль "Календарь"<br/>(<img src={TimeLineIcon}></img>)
                </button>
            </div>

            <div className="content-tabs">
                <div className={toggleState === 1 ? "content  active-content" : "content"}>

                    <h2>Модули дополнительной информации и возможности взаимодействия с картой</h2>
                    <hr />
                    <p>
                        На главной странице веб-приложения (изображение 1) в нижнем левом углу расположены модули для получения дополнительной информации и взаимодействия с картой.
                        <br/>
                        <figure>
                            <img src={Tab1Module}/>
                            <figcaption >Изображение 1 - Модули дополнительной информации и взаимодействия с картой</figcaption>
                        </figure>
                        Описание модулей:<br/>
                        <ol>
                            <li><span className="span">Модуль для отображения координат курсора мыши на карте в формате: градусы, минуты, секунды.</span></li>
                            <br/><li><span className="span">Модуль для измерения расстояний «Линейка». Для его активации необходимо нажать на иконку с изображением линейки. После активации иконка меняется на крестик, а вокруг кнопки появляется зелёный контур, что означает, что модуль включён (изображение 2)
                            <figure>
                                <img width={1000} src={Ruler}/>
                                <figcaption className={"figcaption"}>Изображение 2 - Пример работы модуля «Линейка».</figcaption>
                            </figure>
                                При первом клике по карте устанавливается начальная точка, от которой начинается отсчёт. Затем пользователь указывает следующую точку в нужном месте.
                                После установки двух точек на карте отображается пунктирная линия между ними, а также формируется информационное окно. В этом окне показывается расстояние между первой и второй точкой, а также азимут.
                                Если требуется отметить несколько независимых линий, пользователь должен завершить текущую линию (поставив вторую точку), затем нажать клавишу Esc и кнопку с иконкой крестика. После этого можно строить новую линию.
                                Отключить модуль можно двумя способами: Нажать на кнопку с иконкой крестика или дважды нажать клавишу Esc на клавиатуре.
                            </span></li>
                            <br/><li><span className="span">Информационный модуль, отображающий текущий масштаб карты в километрах и милях.</span></li>
                            <br/><li><span className="span">Кнопки с иконками «+» и «−» предназначены для изменения масштаба карты: «+» — увеличивает масштаб, «−» — уменьшает.
                            Также масштаб можно регулировать с помощью колеса мыши.</span></li>
                        </ol>
                    </p>
                </div>

                <div className={toggleState === 2 ? "content  active-content" : "content"}>

                    <h2>Набор дополнительных инструментов</h2>
                    <hr />
                    <p>
                       На Главной станице веб-приложения в правом верхнем углу находится кнопка с иконкой шестерёнки (изображение 1).
                        <figure>
                            <img src={NavBarPNG}/>
                            <figcaption >Изображение 1</figcaption>
                        </figure>
                        При нажатии на кнопку открывается меню с набором дополнительных инструментов (изображение 2).
                        <figure>
                            <img src={NavBar}/>
                            <figcaption >Изображение 2 - Развёрнутый модуль дополнительных инструментов</figcaption>
                        </figure>
                        <ol>
                            <li><span className="span">Для формирования отчёта необходимо нажать соотвествующую кнопку и заполнить форму (изображение 3):
                                <figure>
                                    <img src={ModalPNG}/>
                                    <figcaption >Изображение 3 - Окно для формирования отчёта в формате PDF</figcaption>
                                </figure>
                                При нажатии на кнопку «Отчёт в PDF» открывается окно, в котором нужно заполнить соответствующие поля: район обнаружения ТВВ и экранирование облачностью (в процентах от 0 до 100).<br/>
                                После проверки на наличие данных появится возможность открыть отчёт в формате PDF (изображение 4)
                                <figure>
                                    <img src={ModalListPNG}/>
                                    <figcaption >Изображение 4 - Отчет о точках вероятного возгорания в формате PDF</figcaption>
                                </figure>
                                В окне «Отчёт в SHP» нужно выбрать только район обнаружения ТВВ. После проверки на наличие данных появится возможность скачать отчёт в формате SHP.
                            </span></li>
                            <br/><li><span className="span">Стиль подстилающей карты можно изменить, выбрав один из предложенных вариантов — «Улицы», «Спутник», «Тёмная», «ESRI» — с помощью соответствующего флажка (CheckBox).
                            </span></li>
                            <br/><li><span className="span">Во вкладке "Отображение дополнительных данных" находятся несколько инструментов:<br/>
                            Переключатель «Точки возгорания» управляет отображением слоя точек вероятного возгорания (ТВВ) на карте (изображение 5).
                            <figure>
                                    <img width={1000} src={TBB}/>
                                    <figcaption >Изображение 5 - Активный слой "Точки возгорания"</figcaption>
                                </figure>
                            При активации слоя все точки вероятного возгорания (ТВВ) в зависимости от текущего масштаба карты объединяются в кластеры.<br/>
                            Кластер представляет собой овал, который группирует несколько ТВВ и принимает цвет наиболее высокой температурной отметки, зафиксированной среди входящих в него точек.<br/>
                            Если переключатель «Точки возгорания» активен, под ним отображается информационная строка. В ней представлены цветовые индикаторы в виде овалов, 
                            соответствующих цветам кластеров на карте, а также диапазоны температур ТВВ внутри кластеров каждого цвета. Температура указана в градусах Кельвина.<br/><br/>

                            {/* Описание алгоритмов выделения пожаров */}
                            «Точки возгорания» представляют собой данные, полученные с помощью алгоритмов AVAFO (разрешение 750 м.) и AFIMG (разрешение 375 м.), которые  разработаны для обнаружения ТВВ. 
                            Выявление «горячих точек» основано на данных со спутниковых приборов VIIRS КА Suomi NPP, NOAA-20, 21. Используются спектральные каналы VIIRS в средне- и тепловом инфракрасном диапазонах, 
                            позволяющих выявлять пиксели значительно отличающихся по яркостной температуре от фоновых значений. Алгоритм также включает процедуры фильтрации ложных срабатываний.<br/><br/>

                            Переключатель «Границы регионов» активирует слой, отображающий на карте границы субъектов Российской Федерации (изображение 6).
                            <figure>
                                    <img width={1000} src={RegionZone}/>
                                    <figcaption >Изображение 6 - Активный слой границ субъектов Российской Федерации</figcaption>
                            </figure>
                            Переключатель "Заповедники" активирует слой, отображающий полигоны заповедников (изображение 7).
                            <figure>
                                    <img width={1000} src={NatureReservesPNG}/>
                                    <figcaption >Изображение 7 - Активный слой границ заповедников</figcaption>
                            </figure>
                            Переключатель "Населёные пукнты (5км от ТВВ)" активирует слой, отображающий населённые пункты. В случае нахождения ТВВ в радиусе 5 км от населённого пункта, его название выделяется жёлтым цветом (изображение 8).
                            <figure>
                                    <img width={1000} src={CityTBB}/>
                                    <figcaption >Изображение 8 - Активный слой населёных пунктов (5км от ТВВ)</figcaption>
                            </figure>
                            </span></li>
                            <li><span className="span">Во вкладке "Спутниковые снимки" находятся переключатели, отвечающие за отображение данных со спутников (изображение 2).<br/>
                                Одновременная активация снимков с нескольких спутников недоступна.<br/>
                                При выборе одного из спутников становятся доступны дополнительные параметры отображения снимков, представленные в виде флажков (изображение 9).
                                <figure>
                                    <img width={1000} src={SuomiNPP}/>
                                    <figcaption >Изображение 9 - Отображение спутникового снимка (Suomi NPP)</figcaption>
                                </figure>
                            </span></li><br/>
                            <li><span className="span">Дополнительный блок инструментов предназачен для сортировки ТВВ по временным интервалам: за текущий день (с 00:00:01 по текущее время), 24 часа, неделя.<br/>
                                При выборе одного из указанных вариантов в нижней части интерфейса отображается информационная таблица, информирующая о текущем выбранном интервале (изображение 10).
                                <figure>
                                    <img src={SortNavBar}/>
                                    <figcaption >Изображение 10 - Сортировка ТВВ по временным интервалам</figcaption>
                                </figure>
                            </span></li>
                            <li><span className="span">Блок "Сбор данных за несколько дней (не более 7 дней)" предназначен для получения информации за указанный временной промежуток. Для использования функционала необходимо нажать на поле выбора даты, после чего откроется интерфейс календаря (изображение 11).
                                <figure>
                                    <img src={Calendar}/>
                                    <figcaption >Изображение 11 - Календарь</figcaption>
                                </figure>
                                После выбора дат необходимо нажать кнопку "Сохранить". Указанный временной промежуток отображается в информационном поле в нижней части экрана (изображение 12).
                                <figure>
                                    <img src={CalendarInfo}/>
                                    <figcaption >Изображение 12 - Информация о временном промежутке</figcaption>
                                </figure>
                                Для сброса установленного фильтра следует нажать кнопку «Сбросить». В этом случае значения дат будут возвращены к текущей дате.
                            </span></li>
                        </ol>
                    </p>
                </div>

                <div className={toggleState === 3 ? "content  active-content" : "content"}>

                    <h2>Описание модуля "Календарь"</h2>
                    <hr />
                    <p>
                        На Главной станице веб-приложения в правом верхнем углу находится кнопка с иконкой календаря (изображение 1).
                        <figure>
                            <img src={TimeLinePNG}/>
                            <figcaption >Изображение 1 - Кнопка активации модуля "Календраь"</figcaption>
                        </figure>
                        При нажатии на кнопку раскрывается окно календаря (изображение 2).
                        <figure>
                            <img src={TimeLineFirst}/>
                            <figcaption >Изображение 2 - Выбор даты</figcaption>
                        </figure>
                        После открытия окна требуется нажать на иконку календаря, после чего откроется интерфейс выбора года (изображение 3).<br/>
                        После выбора года становится доступным окно выбора месяца (изображение 4).
                        <figure>
                            <img src={TimeLineYear}/>
                            <figcaption >Изображение 3 - Окно выбора года</figcaption>
                        </figure>
                        <figure>
                            <img src={TimeLineMounth}/>
                            <figcaption >Изображение 4 - Окно выбора месяца</figcaption>
                        </figure>
                        После выбора года и месяца формируется календарная сетка, отображающая все дни выбранного месяца (изображение 5).
                        <figure>
                            <img width={1000} src={TimeLineDays}/>
                            <figcaption >Изображение 5 - Календарная линия</figcaption>
                        </figure>
                        Дни, в которых отсутствует информации о ТВВ, отмечены синим цветом.<br/>
                        Дни, в которых есть информация о ТВВ, отмечается зелёным цветом.<br/>
                        Выбранный день отмечается белым цветом (изображение 6).
                        <figure>
                            <img width={1000} src={TimeLineSelectDay}/>
                            <figcaption >Изображение 6 - Календарная линия </figcaption>
                        </figure>
                    </p>
                </div>
            </div>
        </div>
    );
}
export default Tabs;